import { Button, Col, Form, Offcanvas, Row } from "react-bootstrap";

function CustomSection({
  show,
  hide,
  index,
  setIndex,
  sectionData,
  setSectionData,
  setCustomData,
  mode,
  setMode,
}) {
  const handleSubmit = () => {
    if (mode === "add") {
      setCustomData((prev) => [...prev, sectionData]);
    } else {
      setCustomData((prev) =>
        prev.map((item, i) => (i === index ? sectionData : item)),
      );
    }
    hide();
    setIndex(null);
    setMode("");
    setSectionData("");
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSectionData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  return (
    <Offcanvas show={show} onHide={hide} placement="end" style={{ width: 600 }}>
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>
          {mode === "add" ? "Add New Custom" : `Custom ${index + 1}`}
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <Row>
          <Col md={6}>
            <Form.Group className="mb-2">
              <Form.Label>Title</Form.Label>
              <Form.Control
                placeholder="Enter Title"
                type="text"
                name="title"
                value={sectionData?.title}
                onChange={handleChange}
              />
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group className="mb-2">
              <Form.Label>Organization / Subtitle</Form.Label>
              <Form.Control
                placeholder="Enter Organization / Subtitle"
                name="subtitle"
                value={sectionData?.subtitle}
                onChange={handleChange}
              />
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group className="mb-2">
              <Form.Label>Start Date</Form.Label>
              <Form.Control
                type="date"
                name="startDate"
                value={sectionData?.startDate}
                onChange={handleChange}
              />
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group className="mb-2">
              <Form.Label>End Date</Form.Label>
              <Form.Control
                type="date"
                name="endDate"
                value={sectionData?.endDate}
                onChange={handleChange}
              />
            </Form.Group>
          </Col>
          <Col md={12}>
            <Form.Group>
              <Form.Label>Summary / Details</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                placeholder="Enter Summary / Details"
                name="description"
                value={sectionData?.description}
                onChange={handleChange}
              />
            </Form.Group>
          </Col>
          <div className="d-flex justify-content-end gap-2 mt-3">
            <Button onClick={handleSubmit}>
              {mode === "add" ? "Add New" : "Update"}
            </Button>
          </div>
        </Row>
      </Offcanvas.Body>
    </Offcanvas>
  );
}

export default CustomSection;
